<template>
    <div class="portrait-props-wrapper">
        <div class="portrait-condition">
            <div class="condition-title">{{ titileLabel }}</div>
            <div class="condition-box">
                <PropMutliSelect
                    class="multi-select"
                    v-for="(item, idx) in portrait"
                    :key="idx"
                    :title="item.name"
                    :initData="users"
                    :options="item.value"
                    @deleteSelected="deleteSelected"
                    @clickSelectIds="clickSelectIds"
                />
            </div>
        </div>
    </div>
</template>

<script>
import PropMutliSelect from "./PropMutliSelect";

export default {
    name: "PortraitProps",
    props: ["data"],
    components: {
        PropMutliSelect
    },
    computed: {
        users() {
            return this.getStorePorp("currentAnswer").props.effectUser;
        },
        portrait() {
            return this.getStorePorp("answerProp").userPortrait;
        },
        titileLabel() {
            return this.$t("zhiji.answer.portraitConditions");
        }
    },
    methods: {
        getStorePorp(propName) {
            return this.$store.state.zhiji.questionEdit[propName];
        },
        deleteSelected(data) {
            this.updateStoreProp(data);
        },
        clickSelectIds(data) {
            this.updateStoreProp(data);
        },
        updateStoreProp(data) {
            this.$store.commit("zhiji/editQsUpdateAnswer", {
                type: "updateProp",
                effectUser: data
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.portrait-condition {
    .condition-title {
        padding: 9px 16px 10px 16px;
        background: #f2f7fb;
        border-width: 1px 0 1px 0;
        border-style: solid;
        border-color: #dce6f0;
        margin-top: -1px;
    }
}
</style>
